import { useContext } from 'react';

import { useAppSelector } from 'hooks/redux';
import { useIsNewDesign } from 'hooks/useIsNewDesign';
import { resolveIconSet } from 'helpers/iconSet';
import { IconSetContext } from 'components/icons/IconSetContext';
import { IconSet } from 'types/icons';

/** What the photographer picked, before the page scoping. Only `IconSetProvider` wants this. */
export const useConfiguredIconSet = (): IconSet | null => {
  const design = useAppSelector((state) => state.collection.design);
  const isNewDesign = useIsNewDesign();

  return resolveIconSet(design, isNewDesign);
};

/** The set actually in force here — null off the gallery, where legacy artwork takes over. */
export const useIconSet = (): IconSet | null => useContext(IconSetContext)?.set ?? null;
